import * as React from 'react';
import { flow, each, get } from 'lodash';
import { formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { actions as quoteActions } from '../../../../../../services/quote/reducer';
import {IClaim, IConviction, IDriver, IVehicle, IVehicleDriver} from '../../../../../../data/api/models';
import Driver from '../Driver';
import * as uuid from 'uuid/v4';
import * as moment from 'moment';
import CreateDriverButton from '../../../../components/CreateDriverButton';

interface IDriversProps {
  count: number;
  drivers: IDriver[];
  fields: any;
  dispatch: any;
  change: any;
  declaration: any;
  claimOptions: any;
  convictionOptions: any;
  convictionDescriptions: any;
  vehicles: IVehicle[];
}

interface IDriversState {
  showAddDriverButton: boolean;
}

const defaults = {
  id: '',
  proposer: false,
  dob: '',
  title: '',
  firstName: '',
  lastName: '',
  typeOfLicence: '',
  lengthOfLicence: '',
  nonEquineTrade: '',
  vehicles: [],
  claims: [],
  convictions: [],
};

class Drivers extends React.Component<IDriversProps, IDriversState> {
  public state = {
    showAddDriverButton: false,
  };

  public componentDidMount() {
    const { fields, count, declaration } = this.props;
    let i;
    for (i = 0; i < count; i++) {
      if (i >= fields.length) {
        const newDriverId = uuid();
        const defaultDriver = {
          id: newDriverId,
          ...defaults,
        };

        fields.push(defaultDriver);
      }
    }
    for (i = fields.length - 1; i >= 0; i--) {
      if (i >= count) {
        fields.remove(i);
      }
    }

    if (
      declaration[11] === 'true' || declaration[18] === 'true'
    ) {
      this.setState({ showAddDriverButton: true });
    }
  }

  public componentWillReceiveProps(nextProps) {
    const { declaration } = this.props;

    const questionOne = declaration[11];
    const questionOneNext = nextProps.declaration[11];
    const questionTwo = declaration[18];
    const questionTwoNext = nextProps.declaration[18];

    const hasChanged = questionTwo !== questionTwoNext || questionOne !== questionOneNext;
    if (hasChanged) {
      if (
        questionOneNext === 'true' || questionTwoNext === 'true'
      ) {
        this.setState({ showAddDriverButton: true });
      } else if (
        questionOneNext === 'false' && questionTwoNext === 'false'
      ) {
        this.setState({ showAddDriverButton: false });
      }
    }
  }

  private addField = (newDriver) => {
    const { dispatch, change, fields } = this.props;

    const newDriverValues = {
      id: uuid(),
      ...defaults,
      ...newDriver,
    };

    fields.push(newDriverValues);
    dispatch(change('driverCount', fields.length + 1));
  }

  public deleteDriver = (index) => {
    const { dispatch, change, fields, vehicles, drivers } = this.props;

    each(vehicles,  (vehicle: IVehicle, index) => {
      each(vehicle.drivers, (vehicleDriver: IVehicleDriver, driverIndex) => {
        if (vehicleDriver.driver === drivers[index].id) {
          vehicle.drivers.splice(driverIndex, 1);
          return false;
        }
      });
      each(vehicle.equineTradeExtendedUsers, (vehicleDriver: IVehicleDriver, driverIndex) => {
        if (vehicleDriver.driver === drivers[index].id) {
          vehicle.equineTradeExtendedUsers.splice(driverIndex, 1);
          return false;
        }
      });
      each(vehicle.nonEquineTradeExtendedUsers, (vehicleDriver: IVehicleDriver, driverIndex) => {
        if (vehicleDriver.driver === drivers[index].id) {
          vehicle.nonEquineTradeExtendedUsers.splice(driverIndex, 1);
          return false;
        }
      });

      dispatch(change('vehicles.' + index + '.drivers', vehicle.drivers));
      dispatch(change('vehicles.' + index + '.equineTradeExtendedUsers', vehicle.equineTradeExtendedUsers));
      dispatch(change('vehicles.' + index + '.nonEquineTradeExtendedUsers', vehicle.nonEquineTradeExtendedUsers));
    });

    fields.remove(index);
    dispatch(change('driverCount', fields.length - 1));
  }

  public render() {
    const {
      fields,
      drivers,
      dispatch,
      change,
      claimOptions,
      convictionOptions,
      convictionDescriptions,
    } = this.props;
    const { showAddDriverButton } = this.state;

    return (
      <>
        {(showAddDriverButton || fields.length > 0) && (
          <div className="sub-content-container">
            {fields.map((driver, index) => {
              return (
                <div key={index}>
                  <Driver
                    name={driver}
                    driver={drivers[index]}
                    index={index}
                    dispatch={dispatch}
                    change={change}
                    claimOptions={claimOptions}
                    convictionOptions={convictionOptions}
                    convictionDescriptions={convictionDescriptions}
                    deleteDriver={this.deleteDriver}
                  />
                  {index + 1 !== fields.length && (
                    <hr />
                  )}
                </div>
              );
            })}
            {showAddDriverButton && (
              <CreateDriverButton
                callback={this.addField}
                dispatch={dispatch}
                change={change}
              />
            )}
          </div>
        )}
      </>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const drivers = selector(state, 'drivers');
      const declaration = selector(state, 'declaration');

      return {
        quote: state.quote,
        drivers,
        declaration,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(Drivers);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Drivers/components/Drivers/index.tsx